import React from 'react'
import Grid from '@material-ui/core/Grid'
import Input from 'Components/Input'
import Switch from 'Components/Switch'
import Form from 'Components/Form'
import moment from 'moment'

import Utils from 'EurestoFonction/Utils'
import Constants from 'EurestoFonction/Constants'
import Data from 'EurestoClass/Data'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import EurestoTable from 'Components/EurestoTable'
import { Tooltip } from "@material-ui/core";

import DataComponent from 'EurestoComponents/DataComponents'

moment.locale('fr')

const stocks = [{
    help: 'C\'est l\'unité généralement utilisée: les autres unités sont des multiples de l\'unité de référence.',
    type_unite_id: 1,
    unite_id: undefined,
    rapport: undefined,
    arrondi: undefined
}, {
    help: 'C\'est l\'unité d\'inventaire, de consultation et d\'édition du stock.\n' +
        'Tous les mouvements de stock seront convertis en unité de stockage.',
    type_unite_id: 2,
    unite_id: undefined,
    rapport: undefined,
    arrondi: undefined
}, {
    help: 'C\'est l\'unité utilisée lorsque le produit est intégré dans une fiche technique.',
    type_unite_id: 3,
    unite_id: undefined,
    rapport: undefined,
    arrondi: undefined
}, {
    help: 'C\'est l\'unité utilisée par les DBM (= demandes besoins marchandises)',
    type_unite_id: 4,
    unite_id: undefined,
    rapport: undefined,
    arrondi: undefined
}, {
    help: 'C\'est l\'unité utilisée lorsque le produit est vendu.\n' +
        'Cette unité est importante pour les produits vendus en l\'état.\n' +
        'Exemple:\n' +
        '- une bouteille de liqueur est stockée en Bouteille 70 cl\n' +
        '- on vend des doses de 4 Cl: l\'unité de Vente est donc : 4 x cl',
    type_unite_id: 5,
    unite_id: undefined,
    rapport: undefined,
    arrondi: undefined
}, {
    help: 'Prix de référence pour les étiquettes de rayonnage, exemple (prix au Litre, au Kg)',
    type_unite_id: 6,
    unite_id: undefined,
    rapport: undefined,
    arrondi: undefined
}]

export default class extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            stocks: props.stocks && props.stocks.map(stock => ({
                ...stock,
                help: stocks.find(stck => stck.type_unite_id === stock.type_unite_id).help
            })) || stocks,
            stock: {
                type_unite_id: 2,
                categorie_unite_id: undefined,
                unite_id: undefined,
                rapport: undefined,
                arrondi: undefined
            },
            autoUpdateSotck: 1,
            index: (props.data || []).length > 0 ? 0 : undefined,
            action: 'view',
            key: Utils.getRandomNumber(),
            key_grid: Utils.getRandomNumber(),
            datagridId: Utils.getRandomNumber(),
            position: 0,
            columns: [
                {
                    header: '',
                    accessor: 'help',
                    width: 25,
                    Cell: (row) => {
                        console.log(row)
                        return <Tooltip disableTouchListener title={row.help} placement="top">
                            <i className={'ei-commun_question'} />
                        </Tooltip>
                    }
                },
                {
                    header: EurestoI18n.t('gestion:Type d\'unité'),
                    accessor: 'type_unite_id',
                    Cell: (row) => {
                        let typeUnite = Data.get(Constants.module.GESTION, Constants.donnee.type_unite, { id: row.type_unite_id })
                        return typeUnite && <span className="pull-left">{typeUnite.libelle}</span> || ''
                    }
                },
                {
                    header: EurestoI18n.t('gestion:Unité'),
                    accessor: 'unite_id',
                    Cell: (row) => {
                        let unite = Data.get(Constants.module.GESTION, Constants.donnee.unite, { id: row.unite_id })
                        return unite && unite.libelle || ''
                    }
                },
                {
                    header: EurestoI18n.t('gestion:Valeur'),
                    id: 'rapport',
                },
                {
                    header: EurestoI18n.t('gestion:Arrondi'),
                    id: 'arrondi',
                },
            ]
        }
    }

    componentDidUpdate() {
        $('#' + this.state.datagridId + '-body').scrollTop(this.state.position)
    }

    onSave = () => {
        const index = this.state.stocks.findIndex(s => s.type_unite_id === this.state.stock.type_unite_id)
        let { stocks, stock } = this.state

        if (this.state.autoUpdateSotck === 1 && (stock.type_unite_id === 1 || stock.type_unite_id === 2 || stock.type_unite_id === 6)) {
            if (stock.type_unite_id === 2) {
                const unite = Data.get(Constants.module.GESTION, Constants.donnee.unite, { id: stock.unite_id })
                stocks = stocks.map(st => ({
                    ...st,
                    unite_id: (st.type_unite_id === 1 || st.type_unite_id === 3 || st.type_unite_id === 6) && (unite.unite_id === null ? unite.id : unite.unite_id) || stock.unite_id,
                    rapport: (st.type_unite_id === 1 || st.type_unite_id === 3 || st.type_unite_id === 6) && 1 || stock.rapport,
                    arrondi: (st.type_unite_id === 1 || st.type_unite_id === 3 || st.type_unite_id === 6) ? 0 : stock.arrondi,
                }))
            } else {
                const i = this.state.stocks.findIndex(s => s.type_unite_id === 1)
                stocks[i] = {
                    ...stocks[i],
                    unite_id: stock.unite_id,
                    rapport: stock.rapport || 1,
                    arrondi: stock.arrondi || 0,
                }
                const i3 = this.state.stocks.findIndex(s => s.type_unite_id === 3)
                stocks[i3] = {
                    ...stocks[i3],
                    unite_id: stock.unite_id,
                    rapport: stock.rapport || 1,
                    arrondi: stock.arrondi || 0,
                }
                const i6 = this.state.stocks.findIndex(s => s.type_unite_id === 6)
                stocks[i6] = {
                    ...stocks[i6],
                    unite_id: stock.unite_id,
                    rapport: stock.rapport || 1,
                    arrondi: stock.arrondi || 0,
                }

            }
        } else {
            stocks[index] = {
                ...stocks[index],
                ...stock
            }
        }

        this.setState({
            stock: stock,
            stocks: stocks,
            key: Utils.getRandomNumber(),
        }, this.props.onChange(stocks, this.props.name))
    }

    onView = i => _ => {
        let stocks = this.state.stocks || []
        const index = (this.state.stocks || []).length > 0 ? i || 0 : undefined

        console.log(stocks[index])

        this.setState({
            index: index,
            stock: index >= 0 && stocks[index] || {},
            action: 'view',
            position: $('#' + this.state.datagridId + '-body').scrollTop(),
            key: Utils.getRandomNumber()
        })
    }

    onChange = (data, name) => {
        let stock = this.state.stock || {}

        if (name === 'categorie_unite_id') {
            const cui = stock.categorie_unite_id || stock.unite_id && Data.get(Constants.module.GESTION, Constants.donnee.unite, { id: stock.unite_id }).unite_categorie_id
            if (data !== cui) stock.unite_id = undefined
        }
        stock[name] = data
        this.setState({
            stock: stock
        })
    }

    onDelete = _ => {
        const stock = this.state.stock
        let stocks = this.state.stocks || []
        stocks.splice(this.state.index, 1)
        const index = (this.state.stocks || []).length > 0 ? 0 : undefined
        this.setState({
            index: index,
            stocks: stocks,
            stock: index >= 0 && stocks[index] || {},
            action: 'view',
            key_grid: Utils.getRandomNumber(),
            position: $('#' + this.state.datagridId + '-body').scrollTop(),
            key: Utils.getRandomNumber()
        }, this.callChangeProps(stock.type))
    }

    onCancel = _ => {
        this.setState({
            stock: {},
            action: 'add',
            index: undefined,
            key: Utils.getRandomNumber()
        })
    }

    form = (disabled, autoFocus) => (
        <Grid container style={{ margin: 0, padding: 0 }} spacing={0} direction={'column'} justify={'center'}
            alignItems={'stretch'}>
            <Input
                name="type_unite_id"
                disabled={true}
                type="text"
                value={this.state.stock.type_unite_id && Data.get(Constants.module.GESTION, Constants.donnee.type_unite, { id: this.state.stock.type_unite_id }).libelle || ''}
                title={EurestoI18n.t('crm:Type d\'Unité')}
            />
            <Grid container style={{ margin: 0, padding: 0 }} spacing={0}>
                <Grid item style={{ margin: 0, padding: 5 }} xs={6}>
                    <DataComponent
                        title={EurestoI18n.t('gestion:Catégorie d\'Unité')}
                        name="categorie_unite_id"
                        onChange={this.onChange}
                        disabled={disabled}
                        type={Constants.typeSaisie.ComboSimple}
                        data={this.state.stock.categorie_unite_id || this.state.stock.unite_id && Data.get(Constants.module.GESTION, Constants.donnee.unite, { id: this.state.stock.unite_id }).unite_categorie_id || undefined}
                        object={Constants.donnee.categorie_unite}
                        module={Constants.module.GESTION}
                    />
                </Grid>
                <Grid item style={{ margin: 0, padding: 5 }} xs={6}>
                    <DataComponent
                        key={'unite_id-' + this.state.stock.categorie_unite_id}
                        title={EurestoI18n.t('gestion:Unité')}
                        name="unite_id"
                        onChange={this.onChange}
                        disabled={disabled}
                        type={Constants.typeSaisie.ComboSimple}
                        data={this.state.stock.unite_id}
                        object={Constants.donnee.unite}
                        module={Constants.module.GESTION}
                        search={Object.assign(this.state.stock.categorie_unite_id && { unite_categorie_id: this.state.stock.categorie_unite_id } || {}, this.state.stock.type_unite_id === (1 || 3 || 6) && { unite_id: null } || {})}
                    />
                </Grid>
            </Grid>
            <Grid container style={{ margin: 0, padding: 0 }} spacing={0}>
                <Grid item style={{ margin: 0, padding: 5 }} xs={6}>
                    <Input
                        onChange={this.onChange}
                        name="rapport"
                        min={0}
                        disabled={disabled}
                        type="number"
                        value={this.state.stock.rapport || ''}
                        title={EurestoI18n.t('crm:Valeur')}
                    />
                </Grid>
                <Grid item style={{ margin: 0, padding: 5 }} xs={6}>
                    <Input
                        onChange={this.onChange}
                        name="arrondi"
                        min={0}
                        disabled={disabled}
                        type="number"
                        value={this.state.stock.arrondi || ''}
                        title={EurestoI18n.t('crm:Arrondi')}
                    />
                </Grid>
            </Grid>
            <Switch key={'autoUpdateSotck-' + this.state.autoUpdateSotck} onChange={() => {
                this.setState({
                    autoUpdateSotck: Math.abs((this.state.autoUpdateSotck - 1))
                })
            }}
                disabled={disabled}
                checked={this.state.autoUpdateSotck === 1}
                label={EurestoI18n.t('crm:Modifier Automatiquement les unités similaires')} />
        </Grid>)

    render() {
        return <EurestoDiv title={EurestoI18n.t('gestion:Unité & Stock')} expandable={true} expanded={true}>
            <Grid container style={{ margin: 0, padding: 0 }} spacing={0}>
                <Grid item style={{ margin: 0, padding: 0 }} xs={8}>
                    <EurestoTable
                        columns={this.state.columns}
                        style={{
                            maxHeight: this.props.maxHeight,
                        }}
                        onClick={(row, index) => this.onView(index)()}
                        filterable={false} sortable={false}
                        selectedRowIndex={this.state.index} datas={this.state.stocks || []} />
                </Grid>
                <Grid item style={{ margin: 0, padding: 0 }} xs={4}
                    key={'grid-form-' + this.state.key}>
                    <Form key={this.state.key + '_form'}
                        borderLeft
                        onClickUpdate={!this.props.disabled}
                        style={{ padding: 0 }}
                        showTab={false}
                        action={this.state.action}
                        isAllow={{
                            update: !this.state.disabled,
                            delete: this.state.stock && this.state.stock.type_unite_id && !this.props.disabled
                        }}
                        onView={this.onView(this.state.index)}
                        onCancel={this.onCancel}
                        onSave={this.onSave}
                        children={this.form} />
                </Grid>
            </Grid>
        </EurestoDiv>
    }
}



// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Component/Stocks/index.js